// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* P2P Ad Details */
.p2p-ad-details-page .dashboard-body {
  padding-bottom: 2rem;
}

.p2p-ad-details-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.p2p-ad-details-title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text, #1e293b);
}

.p2p-ad-details-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: opacity 0.2s, background 0.2s;
}

.p2p-ad-details-btn-back:hover {
  opacity: 0.95;
  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);
}

.p2p-ad-details-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.p2p-ad-details-card__title {
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
}

.p2p-ad-details-params {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem 2rem;
  margin-bottom: 1.5rem;
}

.p2p-ad-details-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.p2p-ad-details-row:last-child {
  margin-bottom: 0;
}

.p2p-ad-details-label {
  min-width: 140px;
  font-size: 0.875rem;
  color: var(--text-muted, #64748b);
}

.p2p-ad-details-value {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text, #1e293b);
}

.p2p-ad-details-badge {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 700;
}

.p2p-ad-details-badge--side.p2p-ad-details-badge--buy {
  background: #16a34a;
  color: #fff;
}

.p2p-ad-details-badge--side.p2p-ad-details-badge--sell {
  background: #dc2626;
  color: #fff;
}

.p2p-ad-details-badge--status.p2p-ad-details-badge--open {
  background: #16a34a;
  color: #fff;
}

.p2p-ad-details-badge--status.p2p-ad-details-badge--closed {
  background: #dc2626;
  color: #fff;
}

.p2p-ad-details-badge--status.p2p-ad-details-badge--partially-filled {
  background: #ea580c;
  color: #fff;
}

.p2p-ad-details-badge--online.p2p-ad-details-badge--yes {
  background: #16a34a;
  color: #fff;
}

.p2p-ad-details-badge--online.p2p-ad-details-badge--no {
  background: #64748b;
  color: #fff;
}

.p2p-ad-details-owner {
  padding-top: 1.25rem;
  border-top: 1px solid #e2e8f0;
}

.p2p-ad-details-owner__title {
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text, #1e293b);
}

.p2p-ad-details-owner__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0 2rem;
}

.p2p-ad-details-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.p2p-ad-details-stat-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.25rem;
  text-align: center;
}

.p2p-ad-details-stat-value {
  display: block;
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  margin-bottom: 0.35rem;
}

.p2p-ad-details-stat-label {
  font-size: 0.85rem;
  color: var(--text-muted, #64748b);
}

.p2p-ad-details-table-wrap {
  overflow-x: auto;
}

.p2p-ad-details-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.p2p-ad-details-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.p2p-ad-details-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text, #1e293b);
}

.p2p-ad-details-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.p2p-ad-details-table tbody tr:hover {
  background: #f8fafc !important;
}

.p2p-ad-details-order-status {
  display: inline-block;
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
}

.p2p-ad-details-order-status--released {
  background: #dcfce7;
  color: #166534;
}

.p2p-ad-details-order-status--paid {
  background: #dbeafe;
  color: #1e40af;
}

.p2p-ad-details-order-status--pending-payment {
  background: #ffedd5;
  color: #c2410c;
}

.p2p-ad-details-empty {
  text-align: center;
  color: var(--text-muted, #64748b);
  padding: 2rem !important;
}

@media (max-width: 900px) {
  .p2p-ad-details-params {
    grid-template-columns: 1fr;
  }
  .p2p-ad-details-owner__grid {
    grid-template-columns: 1fr;
  }
  .p2p-ad-details-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .p2p-ad-details-stats {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/P2P/P2PAdDetailsPage.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* P2P Ad Details */\n.p2p-ad-details-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.p2p-ad-details-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.p2p-ad-details-title {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n}\n\n.p2p-ad-details-btn-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.65rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: opacity 0.2s, background 0.2s;\n}\n\n.p2p-ad-details-btn-back:hover {\n  opacity: 0.95;\n  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);\n}\n\n.p2p-ad-details-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.p2p-ad-details-card__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n}\n\n.p2p-ad-details-params {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem 2rem;\n  margin-bottom: 1.5rem;\n}\n\n.p2p-ad-details-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n\n.p2p-ad-details-row:last-child {\n  margin-bottom: 0;\n}\n\n.p2p-ad-details-label {\n  min-width: 140px;\n  font-size: 0.875rem;\n  color: var(--text-muted, #64748b);\n}\n\n.p2p-ad-details-value {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text, #1e293b);\n}\n\n.p2p-ad-details-badge {\n  display: inline-block;\n  padding: 0.35rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.p2p-ad-details-badge--side.p2p-ad-details-badge--buy {\n  background: #16a34a;\n  color: #fff;\n}\n\n.p2p-ad-details-badge--side.p2p-ad-details-badge--sell {\n  background: #dc2626;\n  color: #fff;\n}\n\n.p2p-ad-details-badge--status.p2p-ad-details-badge--open {\n  background: #16a34a;\n  color: #fff;\n}\n\n.p2p-ad-details-badge--status.p2p-ad-details-badge--closed {\n  background: #dc2626;\n  color: #fff;\n}\n\n.p2p-ad-details-badge--status.p2p-ad-details-badge--partially-filled {\n  background: #ea580c;\n  color: #fff;\n}\n\n.p2p-ad-details-badge--online.p2p-ad-details-badge--yes {\n  background: #16a34a;\n  color: #fff;\n}\n\n.p2p-ad-details-badge--online.p2p-ad-details-badge--no {\n  background: #64748b;\n  color: #fff;\n}\n\n.p2p-ad-details-owner {\n  padding-top: 1.25rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.p2p-ad-details-owner__title {\n  margin: 0 0 1rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text, #1e293b);\n}\n\n.p2p-ad-details-owner__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0 2rem;\n}\n\n.p2p-ad-details-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n\n.p2p-ad-details-stat-box {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 1.25rem;\n  text-align: center;\n}\n\n.p2p-ad-details-stat-value {\n  display: block;\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  margin-bottom: 0.35rem;\n}\n\n.p2p-ad-details-stat-label {\n  font-size: 0.85rem;\n  color: var(--text-muted, #64748b);\n}\n\n.p2p-ad-details-table-wrap {\n  overflow-x: auto;\n}\n\n.p2p-ad-details-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.p2p-ad-details-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.p2p-ad-details-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text, #1e293b);\n}\n\n.p2p-ad-details-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.p2p-ad-details-table tbody tr:hover {\n  background: #f8fafc !important;\n}\n\n.p2p-ad-details-order-status {\n  display: inline-block;\n  padding: 0.3rem 0.65rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.p2p-ad-details-order-status--released {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.p2p-ad-details-order-status--paid {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.p2p-ad-details-order-status--pending-payment {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.p2p-ad-details-empty {\n  text-align: center;\n  color: var(--text-muted, #64748b);\n  padding: 2rem !important;\n}\n\n@media (max-width: 900px) {\n  .p2p-ad-details-params {\n    grid-template-columns: 1fr;\n  }\n  .p2p-ad-details-owner__grid {\n    grid-template-columns: 1fr;\n  }\n  .p2p-ad-details-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .p2p-ad-details-stats {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
